<template>
  <ConsentButton v-if="store.consentButtonShow" />
  <ConsentPopup v-if="store.consentPopupShow" />
  <ConsentModal />
  <div v-for="(group, index) in groupsWithCookies" v-bind:key="index">
    <ConsentSettings :group="group" :index="index" />
  </div>
</template>

<script>
import { store } from './store/index.js'

export default {
  name: 'App',
  data() {
    return {
      store
    }
  },
  computed: {
    groupsWithCookies: function () {
        return this.store.groups.filter(i => i.cookies.length)
    }
  },
  mounted() {
    this.store.groups = window.ampsandCookiesGroups;

    if(!localStorage.getItem('ampsandConsent')) {
      localStorage.setItem('ampsandConsent', JSON.stringify(['functional']));
      localStorage.setItem('ampsandConsentUpdated', Date.now());
    } else {
      const consents = JSON.parse(localStorage.getItem('ampsandConsent'));

      if(localStorage.getItem('ampsandConsentPreferencesSet')) {
        store.consentPopupShow = false;

        if(typeof window.ampsandConsentShowButton === 'undefined' || window.ampsandConsentShowButton) {
          store.consentButtonShow = true;
        }
      }

      consents.forEach(function(consent) {
        consent = consent.charAt(0).toUpperCase() + consent.slice(1);
        window.dispatchEvent(new Event('on' + consent + 'ConsentGranted'));
      })
    }
  },
  unmounted() {
    document.getElementById('accordion-js').remove()
    document.getElementById('drawer-js').remove()
    document.getElementById('modal-window-js').remove()
    document.getElementById('notice-js').remove()
    document.getElementById('floating-button-js').remove()
  }
}
</script>

<style lang="scss">
#ampsandConsentElement {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
